const RIGHT = "R"
const LEFT = "L"
const FORWARD = "F"
const JUMP = "J"
const WALK = "W"
const WASM_URL = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
const HAND_LANDMARKS_MODEL_URL = `/models/hand_landmarker.task`
export {
    RIGHT,
    LEFT,
    FORWARD,
    JUMP,
    WALK,
    WASM_URL,
    HAND_LANDMARKS_MODEL_URL,
}